/* eslint-disable react/prop-types */
import React from 'react';

import styled from 'styled-components';

import Modal from 'components/modal';
import { device } from 'helpers/screenSizes';
import { useLockedBody } from 'hooks';
import useMediaQuery from 'hooks/useMediaQuery';

const Wrapper = styled.div`
  .header {
    svg {
      cursor: pointer;
      position: fixed;
      right: 5px;
      top: 5px;
    }
  }
  .iframe-wrapper {
    @media ${device.up.md} {
      padding-top: 30px;
    }
    iframe {
      width: 800px;
      height: 400px;
      border: 20px solid ${props => props.theme.secondaryBackground};
      border-radius: 10px;
    }
  }
  @media ${device.down.md} {
    .iframe-wrapper {
      iframe {
        width: 100%;
        height: 100%;
      }
    }
    .header {
      display: none;
      // svg {
      //   width: 20px;
      //   height: 20px;
      //   right: 0px;
      //   top: 0px;
      // }
    }
  }
`;

const EmbedYoutube = props => {
  const { whenBelowMd } = useMediaQuery();
  const ModalStyles = {
    content: {
      inset: whenBelowMd ? '40% auto 0% 50%' : '60% auto 0% 50%',
      width: whenBelowMd ? '85%' : '840px',
      height: whenBelowMd ? 'fit-content' : '440px',
      boxShadow: 'none',
    },
  };

  const { isOpen, onClose, src, autoPlay = true } = props;

  const handleAutoplayUrl = autoPlay ? src : src?.replace('autoplay=1', 'autoplay=0');

  useLockedBody(isOpen);

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={ModalStyles}>
      <Wrapper>
        <div>
          <button
            data-testid="close-video-modal"
            className="header naked"
            onClick={onClose}
            type="button"
          >
            <CloseSVG />
          </button>
        </div>
        <div className="iframe-wrapper">
          <iframe title="youtube" src={handleAutoplayUrl} allow="autoplay;fullscreen;" />
        </div>
      </Wrapper>
    </Modal>
  );
};

const CloseSVG = () => {
  return (
    (<svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="CloseSVG">
      <path
        d="M16.0001 31.8334C7.25533 31.8334 0.166748 24.7448 0.166748 16C0.166748 7.25527 7.25533 0.166687 16.0001 0.166687C24.7448 0.166687 31.8334 7.25527 31.8334 16C31.8334 24.7448 24.7448 31.8334 16.0001 31.8334ZM16.0001 28.6667C19.3595 28.6667 22.5813 27.3322 24.9568 24.9567C27.3322 22.5812 28.6667 19.3594 28.6668 16C28.6667 12.6406 27.3322 9.4188 24.9568 7.04334C22.5813 4.66787 19.3595 3.33335 16.0001 3.33335C12.6407 3.33335 9.41886 4.66787 7.0434 7.04334C4.66794 9.4188 3.33342 12.6406 3.33342 16C3.33342 19.3594 4.66794 22.5812 7.0434 24.9567C9.41886 27.3322 12.6407 28.6667 16.0001 28.6667ZM16.0001 13.7612L20.4778 9.28194L22.7182 11.5224L18.2389 16L22.7182 20.4777L20.4778 22.7181L16.0001 18.2389L11.5224 22.7181L9.282 20.4777L13.7613 16L9.282 11.5224L11.5224 9.28194L16.0001 13.7612Z"
        fill="var(--main-text-secondary)"
      />
    </svg>)
  );
};

export default EmbedYoutube;
